import React, { useMemo } from 'react';
import { useEventWebsiteGuestHeadCsrQuery } from './GuestSiteHeadCsr.graphql.generated';
import { extractEventPhoto } from '@shared/utils/eventPhoto';
import { Root } from './GuestSiteHead';

/**
 * Client-side-only GuestSiteHead for the non-SSR fallback path.
 * Makes its own lightweight query for SEO meta tags.
 * Used when the websiteFullySsrGuestSite feature flag is disabled.
 */
export const GuestSiteHeadCsr: React.FC<{ eventHandle: string }> = ({ eventHandle }) => {
  const { data } = useEventWebsiteGuestHeadCsrQuery({
    variables: { eventHandle },
    batchMode: 'fast',
    fetchPolicy: 'cache-first',
    ssr: true,
  });

  const event = data?.eventByName;

  const headData = useMemo(() => {
    const eventPhoto = extractEventPhoto(event);

    return event
      ? {
          hideFromSearchEngines: event.settings.hideFromSearchEngines,
          eventDisplayName: event.info.eventDisplayName,
          imageUrl: eventPhoto?.url,
          handle: event.website,
          ownerFirstName: event.info.ownerFirstName,
          ownerLastName: event.info.ownerLastName,
          fianceeFirstName: event.info.fianceeFirstName,
          pageData: event.pages,
          eventType: event.info.eventType,
          accentPreloadUrl: null,
        }
      : undefined;
  }, [event]);

  return headData ? <Root {...headData} /> : null;
};
